import type { RouteObject } from 'react-router';
import { LeadsPage } from '../leads/LeadsPage';

/** Pizzerias that are already clients, moved here by hand. Their profiles stay at /leads/:id. */
export const routes: RouteObject[] = [{ path: '/clients', element: <LeadsPage segment="client" /> }];
